var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18963(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.372,
    height: 47.373,
    viewBox: "0 0 47.372 47.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18963",
    "data-name": "Group 18963",
    transform: "translate(-445.999 -7031.622)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(449 7035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M216.067,211.534A4.534,4.534,0,1,1,211.534,207,4.534,4.534,0,0,1,216.067,211.534Zm0,0",
    transform: "translate(258.151 6843.774)",
    fill: "#b5153a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M157.238,138.617a4.5,4.5,0,0,0-2.581-2.581,7.525,7.525,0,0,0-2.525-.468c-1.434-.065-1.865-.08-5.5-.08s-4.062.014-5.5.079a7.53,7.53,0,0,0-2.525.468,4.506,4.506,0,0,0-2.582,2.581,7.528,7.528,0,0,0-.468,2.526c-.065,1.434-.08,1.864-.08,5.5s.014,4.062.08,5.5a7.525,7.525,0,0,0,.468,2.525,4.5,4.5,0,0,0,2.581,2.581,7.516,7.516,0,0,0,2.526.468c1.434.065,1.864.079,5.5.079s4.062-.014,5.5-.079a7.516,7.516,0,0,0,2.526-.468,4.5,4.5,0,0,0,2.581-2.581,7.532,7.532,0,0,0,.468-2.525c.065-1.435.079-1.865.079-5.5s-.014-4.062-.079-5.5A7.516,7.516,0,0,0,157.238,138.617Zm-10.6,15.006a6.984,6.984,0,1,1,6.984-6.984A6.984,6.984,0,0,1,146.635,153.623Zm7.26-12.612a1.632,1.632,0,1,1,1.632-1.632A1.632,1.632,0,0,1,153.9,141.011Zm0,0",
    transform: "translate(323.049 6908.669)",
    fill: "#b5153a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M23.686,0A23.686,23.686,0,1,0,47.372,23.686,23.689,23.689,0,0,0,23.686,0ZM37.205,29.294a9.979,9.979,0,0,1-.632,3.3A6.955,6.955,0,0,1,32.6,36.573a9.986,9.986,0,0,1-3.3.632c-1.45.066-1.914.082-5.607.082s-4.157-.016-5.608-.082a9.986,9.986,0,0,1-3.3-.632A6.955,6.955,0,0,1,10.8,32.6a9.976,9.976,0,0,1-.632-3.3c-.067-1.451-.082-1.914-.082-5.608s.016-4.157.082-5.608a9.98,9.98,0,0,1,.632-3.3A6.959,6.959,0,0,1,14.777,10.8a9.988,9.988,0,0,1,3.3-.632c1.45-.066,1.914-.082,5.607-.082s4.157.016,5.607.082a9.99,9.99,0,0,1,3.3.631,6.956,6.956,0,0,1,3.978,3.978,9.978,9.978,0,0,1,.632,3.3c.066,1.45.082,1.914.082,5.608S37.272,27.843,37.205,29.294Zm0,0",
    transform: "translate(445.999 7031.622)",
    fill: "#b5153a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18963);
export default __webpack_public_path__ + "static/media/Group 18963.252b0fac1ff21662ef7ecbacea6a9914.svg";
export { ForwardRef as ReactComponent };